import FlightDataDropzone from './FlightDataDropzone'

export default FlightDataDropzone